module.exports = __webpack_public_path__ + "static/media/gift03_ja.189ccd8e.png";